import * as React from 'react';
import withStyles, {
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@material-ui/core/styles/withStyles';
import {Theme} from '@material-ui/core/styles';
import {PredefinedField} from '~common/lib/types';
import {TextFieldProps} from '@material-ui/core/TextField';
import URLManager from '~common/lib/url-manager';
import {FormControl, FormControlLabel, InputLabel, FormHelperText,  Select, MenuItem,} from '@material-ui/core';
import Renderers from '~common/lib/renderers';

const styles = (theme: Theme): StyleRules => ({
  container: {
    marginTop: 15,
    display: 'flex',
    width: '100%'
  },
  formDefField: {
    width: '100%'
  },
  fieldLabel: {
    width: '100%'
  },
  required:{
    color: "red",
    fontWieght: 600,
    fontSize: "0.85rem"
  },
  flexbox: {
    display: "flex",
    width: '100%',
    alignItems: "baseline",
    flexGrow: 1
  },
  flexboxSelect: {
    width: "30%",
    margin: "5px",
    alignItems: "baseline",
  },
  flexboxLabel: {
    fontSize: '.85rem',
    width: "70%",
    margin: "5px",
    alignItems: "baseline",
  },
  displayText: {
    fontSize: '.85rem',
  },
});

interface Props {
  data: any;
  path: string;
  shrink?: boolean;
  onCommitChange: Function;
  policyMessages?: Array<any>;
  value: any | undefined;
  fieldDefinition: any;
  required?: boolean;
}

type State = {
  value?: any;
  open?: boolean;
};

class QuestionField extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {  
        
      value: props.value
    };
  }

  // componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {
  //   this.setState({value:newProps.value})
  // }c
  //


  onSelectChange = (evt: any) => {
    const {onCommitChange} = this.props;
    let {value} = this.state;

    if (value != evt.target.value) {

      const origVal = evt.target.value
      let newVal = evt.target.value;
      if(newVal == "_nullOption") {
        newVal = null
      }

      value = origVal;
      // if(value == "Yes") {
      //   value = true
      // }
      // if(value == "No") {
      //   value = false
      // }

      
      this.setState({value});


      if (onCommitChange && this.props.value != newVal) { 
        onCommitChange(newVal);
      }
      
    }
  };
  static register = () => {
    // console.log("Registering QuestionFieldRenderer")
    if(!Renderers.find("QuestionFieldRenderer")){
      // console.log("Registering QuestionFieldRenderer")
      Renderers.register("QuestionFieldRenderer", withStyles(styles)(QuestionField))
    }
  }

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {data, value, fieldDefinition, required} = this.props;
    console.log("props", this.props)

// Policy mesages here
  if (fieldDefinition.policyMessages) {
    fieldDefinition.policyMessages.sort((a, b) => {
      return b.severity - a.severity;
    });
    let errorTextVal = fieldDefinition.errorText;
    let error: boolean = false;
    var formDefClass = classes.formDefField

    const applicable = fieldDefinition.policyMessages.reduce((acc, m): Array<any> => {
      
      let mp = m.path;
      if (mp.indexOf('/') == 0) {
        mp = mp.substring(1);
      }

      let op = fieldDefinition.path;
      if (op.indexOf('/') == 0) {
        op = op.substring(1);
      }
      if (mp == op) {
        acc.push(m);
      }
      
      return acc;
        
      }, []);

    if (applicable.length > 0) {
            
      if (applicable[0].severity == 2) {
        errorTextVal = applicable[0].title
      } else if (applicable[0].severity == 1){

        
        formDefClass = classes.formDefFieldWarn
        fieldDefinition.helperText = applicable[0].title;
      } else {
        fieldDefinition.helperText = applicable[0].title;
      }
    }
  }
  let titleQuestion = (
    <div className={classes.flexboxLabel}>{fieldDefinition.title}</div> 
  );

  if(required){
    titleQuestion = (
      <div className={classes.flexboxLabel}>{fieldDefinition.title} <span className={classes.required}>&nbsp;*</span>
      </div>
      // <div className={classes.noDocument}>
      //   {noDocumentText || 'No document uploaded'}<span className={classes.required}>&nbsp;*</span>
      // </div>
    );
  }
    
    return (

      <div className={classes.flexbox}>


        {titleQuestion}
      
        <Select
        //id={fieldDefinition.key}
        name={fieldDefinition.key}
        open={this.state.open}
        autoFocus={fieldDefinition.autoFocus}
        error={error}
        className={classes.flexboxSelect}
        multiple={fieldDefinition.allowsMultiples}
        value={value}
        onChange={this.onSelectChange}
        disabled={fieldDefinition.mode == 'Read Only'}
        MenuProps={{
          PaperProps: {
            style: {maxHeight: 300}
          }
        }}
        onKeyPress={(event: any) => {
          var keyPress = event.key;
          var listID: string = '';
          (fieldDefinition.options || []).map((o: any, i: number) => {
            if (
              listID === '' &&
              o.label.toLowerCase().charAt(0) == keyPress.toLowerCase()
            ) {
              listID = fieldDefinition.key + '_' + i;
              if (document.getElementById(listID) != null) {
                const el = document.getElementById(listID);
                if (el) {
                  el.scrollIntoView({behavior: 'smooth'});
                }
              }
            }
          });
          this.setState({open: true});
        }}>
        {fieldDefinition.mode != 'Required' && !fieldDefinition.defaultValue && (
          <MenuItem value="_nullOption">{fieldDefinition.nullOptionLabel}</MenuItem>
        )}
        {fieldDefinition.options && fieldDefinition.options.map((c: any, idx: number) => {
          return (
            <MenuItem id={fieldDefinition.key + '_' + idx} key={idx} value={c.value}>
              {c.label}
            </MenuItem>
          );
        })}
        </Select>
        
        {fieldDefinition.helperText && <FormHelperText>{fieldDefinition.helperText}</FormHelperText>}
      </div>
      

        
    );
  }
}

export default withStyles(styles)(QuestionField);
